import { render, staticRenderFns } from "./stepView.vue?vue&type=template&id=afe53124&scoped=true&"
import script from "./stepView.vue?vue&type=script&lang=js&"
export * from "./stepView.vue?vue&type=script&lang=js&"
import style0 from "./stepView.vue?vue&type=style&index=0&id=afe53124&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe53124",
  null
  
)

export default component.exports